import React from 'react';
import './PhoneFrame.css';
import BottomMenu from '../BottomMenu/BottomMenu';

const topFrame = (
    <div className="phone-frame__top">
        <span className="phone-frame__camera"></span>
        <span className="phone-frame__speaker"></span>
    </div>
)

const bottomFrame = (
    <div className="phone-frame__bottom">
        <span className="phone-frame__button"></span>
    </div>
)

const PhoneFrame = (props) => (
    <div className="mobile-view">
        <div className="phone-frame">
            {topFrame}
            <div className="phone-frame__screen">
                {props.children}
                {BottomMenu()}
            </div>
            {bottomFrame}
        </div>
    </div>
);

export default PhoneFrame;